export default __webpack_public_path__ + "static/media/archivIcon.a15277b8.svg";